import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MobileNavigationState {
    isMainNavigationOpen: boolean;
}

const INITIAL_STATE: MobileNavigationState = {
    isMainNavigationOpen: false,
};

const MOBILE_NAVIGATION_SLICE = createSlice({
    name: "mobileNavigation",
    initialState: INITIAL_STATE,
    reducers: {
        setMobileMainNavigationOpen(state, action: PayloadAction<boolean>) {
            state.isMainNavigationOpen = action.payload;
        },
    },
});

export const { setMobileMainNavigationOpen } = MOBILE_NAVIGATION_SLICE.actions;

export default MOBILE_NAVIGATION_SLICE.reducer;
